@if (show) {
  <!-- grid-action-button: marks this link as a button for the app-wide double-click guard
       (ClickGuardService), which otherwise acts only on <button> and a.btn. -->
  <a
    class="text-decoration-none grid-action-button"
    [class]="params.className"
    [class.disabled]="isDisabled"
    [attr.aria-disabled]="isDisabled"
    (click)="onClick()"
  >
    <i class="fa-lg" [class]="iconClass"></i>
    @if (buttonText) {
      <span class="fw-bold">&nbsp;{{ buttonText }}</span>
    }
  </a>
}
